// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyCardFinderV2PatientResponse } from './pharmacyCardFinderV2PatientResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyCardFinderV2Plan {
    'bin'?: string;
    'cardHolderId'?: string;
    'coverageOrder'?: string;
    'familyUnitNumber'?: string;
    'governmentInsured'?: boolean;
    'groupId'?: string;
    'groupName'?: string;
    'patient'?: PharmacyCardFinderV2PatientResponse | null;
    'pbmName'?: string;
    'pbmPhone'?: string;
    'pbmResponseMessage'?: string;
    'pcn'?: string;
    'planType'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyCardFinderV2Plan>> = [
        {
            "name":     "bin",
            "baseName": "bin",
            "type":     "string"
        },
        {
            "name":     "cardHolderId",
            "baseName": "cardHolderId",
            "type":     "string"
        },
        {
            "name":     "coverageOrder",
            "baseName": "coverageOrder",
            "type":     "string"
        },
        {
            "name":     "familyUnitNumber",
            "baseName": "familyUnitNumber",
            "type":     "string"
        },
        {
            "name":     "governmentInsured",
            "baseName": "governmentInsured",
            "type":     "boolean"
        },
        {
            "name":     "groupId",
            "baseName": "groupId",
            "type":     "string"
        },
        {
            "name":     "groupName",
            "baseName": "groupName",
            "type":     "string"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "PharmacyCardFinderV2PatientResponse"
        },
        {
            "name":     "pbmName",
            "baseName": "pbmName",
            "type":     "string"
        },
        {
            "name":     "pbmPhone",
            "baseName": "pbmPhone",
            "type":     "string"
        },
        {
            "name":     "pbmResponseMessage",
            "baseName": "pbmResponseMessage",
            "type":     "string"
        },
        {
            "name":     "pcn",
            "baseName": "pcn",
            "type":     "string"
        },
        {
            "name":     "planType",
            "baseName": "planType",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyCardFinderV2Plan.attributeTypeMap;
    }
}
